module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/filter-summary/filter-summary.component.scss
// module id = ./src/app/filter-summary/filter-summary.component.scss
// module chunks = main